module.exports = "<div fxLayout=\"row\" fxLayoutAlign=\"center center\"  class=\"not_found\" >\r\n  <h2>Page not found!</h2>\r\n</div>\r\n"